<template>
<div class="block">
    <div class="info">
        <span class="dateTimePicker" v-if="isTalkgroup || ((isUser || isIpRadio) && autoUpdateLocationFlg)">
            <el-tooltip effect="light" placement="top-start" >
                <div v-if="isTalkgroup" slot="content" style="text-align:left" v-t="'message.hint_location_cannot_show_tracking'"></div>
                <div v-else slot="content" style="text-align:left" v-t="'message.hint_location_show_tracking'"></div>
                <el-date-picker prefix-icon="noicon" clear-icon="noicon" v-model="datePickerValue" type="datetimerange" v-on:change="onPickerChange" v-on:input="input" range-separator="To" start-placeholder="Start date" end-placeholder="End date" :disabled="disabled" ref="picker"></el-date-picker>
            </el-tooltip>
        </span>
        <span v-else class="dateTimePicker">
            <el-date-picker prefix-icon="noicon" clear-icon="noicon" v-model="datePickerValue" type="datetimerange" v-on:change="onPickerChange" v-on:input="input" range-separator="To" start-placeholder="Start date" end-placeholder="End date" :disabled="disabled" ref="picker"></el-date-picker>
        </span>
        <el-checkbox class="checkbox" v-model="autoUpdateLocationFlg" :disabled="updateDisabled"><span v-t="'message.action_refresh_latest'"/></el-checkbox>
        <el-select class="selectbox" v-model="selectedValue" :disabled="selectDisabled" style="width:150px" v-on:change="onSelectChange()">
            <el-option
                v-for="item in refreshInterval"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
        </el-select>
        <el-checkbox class="checkbox" v-model="showTimeScale"><span v-t="'message.action_display_timeScale'"/></el-checkbox>
        <el-checkbox class="checkbox" v-model="showTraffic"><span v-t="'message.item_map_traffic'"/></el-checkbox>
        <div :class="{ 'customSlider' : showTimeScale, 'display-none' : !showTimeScale}" id="customSlider">
            <el-slider v-if="showScale" v-model="sliderValue" :disabled="disabled" range show-stops :min="scaleMinVal" :max="0" :step="step" :format-tooltip="format" v-on:change="onScalesChange()" ref="datetimeSlider">
            </el-slider>
            <canvas id="canvas" :class="{ 'canvas' : showTimeScale, 'display-none' : !showTimeScale}"></canvas>
        </div>
    </div>
</div>
</template>

<script>
import constants from './constants.js';

const TIME = {
    second: 1000,
    minute: 1000 * 60,
    hour: 1000 * 60 * 60,
    day: 1000 * 60 * 60 * 24,
}
const SCALE = [
    { condition: TIME.hour * 3, unit: TIME.minute * 30 },
    { condition: TIME.day,      unit: TIME.hour },
    { condition: TIME.day * 3,  unit: TIME.hour * 6 },
    { condition: TIME.day * 10, unit: TIME.day },
    { condition: TIME.day * 30, unit: TIME.day * 2 },
    { condition: TIME.day * 90, unit: TIME.day * 5 }
]
export default {
    props: {
        scales: Object,
        selectedNode: Object,
    },
    data() {
        return {
            sliderValue: [-10080, 0],
            step: 15,
            rangeValue: "",
            disabled: false,
            autoUpdateLocationFlg: false,
            updateDisabled: false,
            today: new Date(),
            yesterday: new Date().setDate(new Date().getDate() - 1),
            showTimeScale: true,
            showTraffic: false,
            refreshInterval: [],
            showScale: true,
            options: {
                ja : [
                        { value: '5', label: '5秒ごと'},
                        { value: '10', label: '10秒ごと' },
                        { value: '30', label: '30秒ごと' },
                        { value: '60', label: '60秒ごと' },
                        { value: '180', label: '3分ごと' },
                        { value: '300', label: '5分ごと' }
                    ],
                en : [
                        { value: '5', label: 'Every 5 Sec'},
                        { value: '10', label: 'Every 10 Sec' },
                        { value: '30', label: 'Every 30 Sec' },
                        { value: '60', label: 'Every 60 Sec' },
                        { value: '180', label: 'Every 3 Min' },
                        { value: '300', label: 'Every 5 Min' }
                    ]
            },
            selectedValue: '30',
            selectDisabled: false,
            datePickerValue: [new Date(), new Date()],
            relativeX: 0,
            relativeY: 0,
            scaleCount: 8,
            ctx: null,
            scaleUnit: 0,
            calcUnit: 0,
            scaleMinVal: -1440,
        };
    },
    methods: {
        format(val) {
            let tempVal = Math.abs(val);
            var minute = tempVal % 60;
            var hour = Math.floor((tempVal % (60 * 24) - (tempVal % 60)) / 60);
            var day = Math.floor(tempVal / (60 * 24));
            let maxDate = new Date(this.datePickerValue[1]);
            let currentDate = new Date(this.datePickerValue[1]);
            currentDate.setDate(currentDate.getDate() - day);
            currentDate.setHours(currentDate.getHours() - hour);
            currentDate.setMinutes(currentDate.getMinutes() - minute);
            return ('00' + (currentDate.getMonth() + 1)).slice(-2) + "/" + ('00' + currentDate.getDate()).slice(-2) + " " + ('00' + currentDate.getHours()).slice(-2) + ":" + ('00' + currentDate.getMinutes()).slice(-2);
        },
        onScalesChange: function() {
            let oldMinVal = this.scales.range.min;
            let oldMaxVal = this.scales.range.max;
            this.scales.range.min = this.sliderValue[0];
            this.scales.range.max = this.sliderValue[1];
            if (this.scales.range.min != oldMinVal) {
                this.scales.timeRange.minTime = new Date(this.scales.timeRange.minTime.getTime() + (this.scales.range.min - oldMinVal) * 60 * 1000);
            }
            if (this.scales.range.max != oldMaxVal) {
                this.scales.timeRange.maxTime = new Date(this.scales.timeRange.maxTime.getTime() + (this.scales.range.max - oldMaxVal) * 60 * 1000);
            }
//            this.showDateTimePicker();
            this.scales.changeFlg = true;
        },
        showRanges() {
            this.sliderValue[0] = this.scaleMinVal;
            this.sliderValue[1] = 0;
            this.scales.range.min = this.scaleMinVal;
            this.scales.range.max = 0;
            this.$refs['datetimeSlider'].$refs['button1'].setPosition(0);
            this.$refs['datetimeSlider'].$refs['button2'].setPosition(100);
            this.disabled = this.scales.disable;
            this.updateDisabled = this.scales.updateDisable;
        },
        onSelectChange: function() {
            this.scales.updateInterval = this.selectedValue;
            this.scales.trackingLastUpdate = this.scales.updateInterval * 2 + 10;
        },
        showDateTimePicker: function(locale) {
            let array = [this.scales.timeRange.minTime.toLocaleString(locale), this.scales.timeRange.maxTime.toLocaleString(locale)];
            this.$refs['picker'].showPicker();
            this.$refs['picker'].hidePicker();
            this.$refs['picker'].userInput = array;
            this.$refs['picker'].handleChange();
            this.$refs['picker'].pickerVisible = this.$refs['picker'].visible = false;
            this.$refs['picker'].blur();
        },
        onPickerChange: function() {
            this.scales.timeRange.minTime = new Date(this.datePickerValue[0]);
            this.scales.timeRange.maxTime = new Date(this.datePickerValue[1]);
            let diff = this.scales.timeRange.maxTime - this.scales.timeRange.minTime;
            this.scaleMinVal = -Math.round(diff / 60 / 1000);
            this.$refs['datetimeSlider'].min = this.scaleMinVal;
            this.showInfo();
        },
        showInfo: function() {
            this.showDateTimePicker('ja-Ja');
            this.showRanges();
            this.scales.changeFlg = true;
            this.createScaleByTimeRange();
            this.drawContext();
        },
        initializeCanvas: function() {
            let customSlider = document.getElementById('customSlider');
            if (!customSlider) return;
            this.canvas = document.getElementById('canvas');
            if (!this.canvas) return;
            this.canvas.height = customSlider.offsetHeight;
            this.canvas.width = customSlider.offsetWidth;
            this.relativeX = this.canvas.width / 100;
            this.relativeY = this.canvas.height / 100;
            this.ctx = this.canvas.getContext('2d');
        },
        getCalcUnitByUnit: function(unit) {
            if (Math.floor(unit / TIME.day) >= 1) {
                return Math.floor(unit / TIME.day);
            } else if (Math.floor(unit / TIME.hour) >= 1) {
                return Math.floor(unit / TIME.hour);
            } else {
                return Math.floor(unit / TIME.minute);
            }
        },
        getStepByUnit: function(unit) {
            if (Math.floor(unit / TIME.day / 30) >= 1){
              return 1440;
            }else if(Math.floor(unit / TIME.day) >= 1) {
                return 60;
            } else if (Math.floor(unit / TIME.hour) >= 1) {
                return 30;
            } else {
                return 15;
            }
        },
        createScaleByTimeRange: function() {
            let diff = this.scales.timeRange.maxTime - this.scales.timeRange.minTime;
            for (var i = 0; i < SCALE.length; i++) {
                if (diff < SCALE[i].condition) {
                    this.scaleUnit = SCALE[i].unit;
                    this.calcUnit = this.getCalcUnitByUnit(this.scaleUnit);
                    this.scaleCount = Math.floor(diff / this.scaleUnit);
                    this.step = this.getStepByUnit(this.scaleUnit);
                    return;
                }
            }
            this.scaleUnit = TIME.day * 90;
            this.calcUnit = this.getCalcUnitByUnit(this.scaleUnit);
            this.scaleCount = Math.floor(diff / this.scaleUnit);
            this.step = this.getStepByUnit(this.scaleUnit);
            return;
        },
        drawContext: function() {
            if (!this.ctx || !this.canvas) return;
            this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
            this.ctx.lineWidth = 1;
            this.ctx.strokeStyle = "rgb(200,200,200)";
            for (var i = 0; i <= this.scaleCount; i++) {
                this.ctx.beginPath();
                this.ctx.moveTo(this.calcPathXPosition(i), 5);
                this.ctx.lineTo(this.calcPathXPosition(i), 10);
                this.ctx.stroke();
                this.ctx.textAlign = this.calcTextAlign(i);
                this.ctx.fillText(this.getScaleLabel(i), this.calcPathXPosition(i), 22, 150);
            };
        },
        resetMaxTime: function() {
            this.sliderValue[1] = 0;
            this.$refs['datetimeSlider'].setPosition(100);
            this.scales.timeRange.maxTime = new Date(this.scales.now);
            let diff = this.scales.timeRange.maxTime - this.scales.timeRange.minTime;
            this.scaleMinVal = -Math.round(diff / 1000 / 60);
            this.$refs['datetimeSlider'].min = this.scaleMinVal;
            this.showInfo();
            this.onScalesChange();
        },
        getScaleLabel: function(val) {
            if (val == this.scaleCount) {
                return this.scales.timeRange.maxTime.toLocaleString("ja-Ja");
            }
            let subtractNumber = (this.scaleCount - val) * this.calcUnit;
            let scaleTime = new Date(this.scales.timeRange.maxTime);
            if  (Math.floor(this.scaleUnit / TIME.day) >= 1) {
                scaleTime.setDate(scaleTime.getDate() - subtractNumber);
                return ('00' + (scaleTime.getMonth() + 1)).slice(-2) + "/" + ('00' + scaleTime.getDate()).slice(-2);
            } else if (Math.floor(this.scaleUnit / TIME.hour) >= 1) {
                scaleTime.setHours(scaleTime.getHours() - subtractNumber);
            } else {
                scaleTime.setMinutes(scaleTime.getMinutes() - subtractNumber);
            }
            return ('00' + (scaleTime.getMonth() + 1)).slice(-2) + "/" + ('00' + scaleTime.getDate()).slice(-2) + " " + ('00' + scaleTime.getHours()).slice(-2) + ":" + ('00' + scaleTime.getMinutes()).slice(-2);
        },
        calcPathXPosition: function(i) {
            if (i == 0) {
                let remainder = (this.scales.timeRange.maxTime - this.scales.timeRange.minTime) % (this.scaleUnit);
                let perRemainder = remainder / (this.scales.timeRange.maxTime - this.scales.timeRange.minTime);
                return this.round((this.canvas.width - perRemainder * this.canvas.width) / this.scaleCount * i + perRemainder * this.canvas.width);
            } else if (i == this.scaleCount) {
                return this.round(this.canvas.width - 1);
            } else {
                let remainder = (this.scales.timeRange.maxTime - this.scales.timeRange.minTime) % (this.scaleUnit);
                let perRemainder = remainder / (this.scales.timeRange.maxTime - this.scales.timeRange.minTime);
                return this.round((this.canvas.width - perRemainder * this.canvas.width) / this.scaleCount * i + perRemainder * this.canvas.width);
            }
        },
        round: function(val) {
            return Math.round(val) + 0.5;
        },
        calcTextAlign: function(val) {
            if (val == 0) {
                return "left";
            } else if (val == this.scaleCount) {
                return "right";
            } else {
                return "center";
            }
        },
        setResize: function() {
            this.initializeCanvas();
            this.drawContext();
        },
        setCurrentTime: function(){
          if(this.sliderValue[1] == 0){
            this.scales.now = new Date();
            this.scales.timeRange.maxTime = new Date(this.scales.now);
          }
          this.initializeCanvas();
          this.drawContext();

        },
        redrawScale() {
            this.showScale = false;
            this.$nextTick(() => {
                 this.showScale = true
            })
        },
    },
    created: function() {
        this.datePickerValue[0].setDate(this.datePickerValue[0].getDate() - 1);
        if (sessionStorage.getItem('trackingInterval') != null) {
            this.autoUpdateLocationFlg = true;
            this.selectedValue = sessionStorage.getItem('trackingInterval');
            this.scales.updateInterval = this.selectedValue;
            this.showTimeScale = false;
        }
        if (sessionStorage.getItem('trackingLastUpdate') != null) {
            this.scales.trackingLastUpdate = Number(sessionStorage.getItem('trackingLastUpdate'));
        } else {
            this.scales.trackingLastUpdate = this.scales.updateInterval * 2;
        }
        this.scales.trackingLastUpdate += 10;
        if (this.$i18n.locale == 'ja') {
            this.refreshInterval = this.options.ja;
        } else {
            this.refreshInterval = this.options.en;
        }
    },
    mounted: function() {
        this.scales.range.min = this.scaleMinVal;
        this.scales.range.max = 0;
        this.scales.timeRange.maxTime = new Date(this.scales.now);
        this.scales.timeRange.minTime = new Date(this.scales.now);
        let minute = this.scales.now.getMinutes();
        this.scales.timeRange.maxTime.setMinutes(minute + this.scales.range.max);
        this.scales.timeRange.minTime.setMinutes(minute + this.scales.range.min);
        this.showRanges();
        this.showDateTimePicker();
        this.createScaleByTimeRange();
        this.initializeCanvas();
        this.drawContext();
        window.addEventListener('resize', this.setResize, false);
        this.redrawScale();
    },
    watch: {
        'scales.disable': function(bool) {
            this.disabled = this.scales.disable;
        },
        'autoUpdateLocationFlg': function(bool) {
            this.scales.autoUpdateLocationFlg = this.autoUpdateLocationFlg;
        },
        'showTraffic': function(bool) {
            this.scales.showTraffic = this.showTraffic;
        },
        'scales.autoUpdateLocationFlg': function(bool) {
            this.autoUpdateLocationFlg = this.scales.autoUpdateLocationFlg;
        },
        'scales.resetMaxTimeFlg': function(bool) {
            if (this.scales.resetMaxTimeFlg) {
                this.resetMaxTime();
                this.scales.resetMaxTimeFlg = false;
            }
        },
        'showTimeScale': function(bool) {
            this.scales.showTimeScale = this.showTimeScale;
        },
        '$i18n.locale': function(locale) {
            if (locale == 'ja') {
                this.refreshInterval = this.options.ja;
            } else {
                this.refreshInterval = this.options.en;
            }
        },
    },
    computed: {
        isTalkgroup: function() {
            if (this.selectedNode == null) {
                return false;
            }
            return (this.selectedNode.data.type == constants.OBJECT_TALKGROUP) ;
        },
        isUser: function() {
            if (this.selectedNode == null) {
                return false;
            }
            return (this.selectedNode.data.type === constants.OBJECT_USER) ;
        },
        isIpRadio: function() {
            if (this.selectedNode == null) {
                return false;
            }
            return (this.selectedNode.data.type === constants.OBJECT_IP_RADIO) ;
        },
    },
    beforeDestroy: function () {
      window.removeEventListener('resize', this.setResize);
    }
}
</script>

<style scoped>

.checkbox {
    margin-left: 30px;
}

.checkbox >>> .el-checkbox__input.is-checked+.el-checkbox__label {
    color:#5171cb
}
.checkbox >>> .el-checkbox__input.is-checked .el-checkbox__inner,
.checkbox >>> .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #5171cb;
    border-color: #5171cb
}

.customSlider >>>.el-slider__bar {
    background-color: #3d7dd3;
}

.customSlider .el-slider__button {
    top: -20px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 30px 9px 0 9px;
    border-color: #3d7dd3 transparent transparent transparent;
    background-color: transparent;
}

.customSlider .el-slider__runway.disabled .el-slider__button {
    border-color: #C0C4CC transparent transparent transparent;
}

.customSlider .el-slider__bar.disabled {
    border-color: #C0C4CC transparent transparent transparent;
}

.customSlider .el-slider__button-wrapper {
    top: -30px;
}

.customSlider .el-slider__stop {
    background-color: #e4e7ed;
}

.customSlider {
    margin-top: 20px;
    position: relative;
    width: calc(100% - 40px);
}

.info {
    margin-top: 10px;
    position: relative;
    width: 100%;
    display: inline-block;
}

.dateTimePicker>.el-input__inner {
    background-image: url('../assets/icon_calendar.svg');
    background-repeat: no-repeat;
    background-position-x: 10px;
    background-position-y: center;
    background-size: 16px 16px;
    height: 45px;
    display: inline-block;
}

.block {
    box-sizing: border-box;
    position: relative;
    width: 100%;
    padding: 0 20px;
}

.canvas {
    position: absolute;
    top: 19px;
}

.display-none {
    display: none;
}
</style>
